import React from 'react'
import {Row, Col} from 'react-bootstrap'
import {graphql, useStaticQuery} from 'gatsby'
import {GatsbyImage, getImage} from 'gatsby-plugin-image'

import Section from '../../components/Section'

import * as styles from './SpottingChickenpox.module.scss'

import ImageWithText from '../../components/ImageWithText'

const SpottingChickenpox: React.FC = () => {
  const {
    allFile: {nodes: images},
  } = useStaticQuery<Queries.SpottingChickenpoxQuery>(query)

  const renderImage = (id: string, alt: string) => {
    const imageData = images.find((img) => img.name === id.toString()) || null
    const image = getImage(imageData?.childImageSharp?.gatsbyImageData || null)
    if (!image) return null
    return <GatsbyImage image={image} alt={alt} className={styles.image} />
  }

  return (
    <Section id="spotting-chickenpox" className="text-center">
      <h2 className="fs-1 fw-bold mb-4">
        Spotting
        <br />
        Chickenpox
      </h2>

      <Row className="py-5 gy-5 gx-lg-5">
        {data.map(({title, imgAlt, text}) => (
          <Col key={title} lg={4}>
            <ImageWithText
              {...{title, text}}
              className="gap-4 px-xl-5"
              img={renderImage(title, imgAlt)}
            />
          </Col>
        ))}
      </Row>

      <p className="fw-semibold">
        Chickenpox is contagious from one to two days before the rash appears
        and until all the blisters have scabbed over. This usually takes about
        five days. Other diseases can cause rashes, so you shouldn’t simply
        assume it’s chickenpox.
      </p>
    </Section>
  )
}

export default SpottingChickenpox

const data = [
  {
    title: 'Fever',
    imgAlt: 'Girl having temperature taken',
    text: 'The illness usually starts with fever, aches and pains and feeling out of sorts.',
  },
  {
    title: 'Rash',
    imgAlt: 'Child with chickenpox rash',
    text: 'Then, an itchy, spotty rash develops, turning from spots to blisters to scabs and crusts. The number of spots can vary from person to person; some people hardly have any, while others are covered head to toe.',
  },
  {
    title: 'Infection',
    imgAlt: 'A chickenpox scab',
    text: 'The infection is spread in the fluid found in chickenpox blisters and the droplets in the coughs or sneezes of someone with the infection.',
  },
]

const query = graphql`
  query SpottingChickenpox {
    allFile(
      filter: {
        relativeDirectory: {eq: "spotting-chickenpox"}
        extension: {ne: "svg"}
      }
    ) {
      nodes {
        name
        childImageSharp {
          gatsbyImageData(width: 150, transformOptions: {fit: CONTAIN})
        }
      }
    }
  }
`
